export namespace UserFlowTypes {
  export type TAccountSelection = {
    ledgerRes: TAccountSelectionLedgerRes[];
    unitRes: TAccountSelectionUnitRes;
    locationName: string;
    reservationData: any;
  };
  export type TReservationPage = {
    reservationData: any;
    ledgerId: string;
    apiRes: any;
  };
  export type TCreateAccount = {
    emailId: string;
    CreatePassword: (
      password: string,
      notify: any,
      error: any,
      hasError: any
    ) => void;
  };
  export type TSignUpValues = {
    userName: string;
    newPassword: string;
    confirmPassword: string;
  };
  export type TUnitList = {
    ledgerId: string;
    label: string;
    unit_type: string;
    unitDetails: {
      unitDescription: string;
      unitCategory: string[];
    };
  };
  export type TAccountDetails = {
    id: string;
    label: string;
    balance: number;
    unitDetails: UserFlowTypes.TUnitList[];
    reservationDetails: UserFlowTypes.TReservation[];
    status?: string;
  };

  export type TCurrentUnitData = {
    category: string[];
    description: string;
  };

  export type TAccountSelectionLedgerRes = {
    gate_access?: TGateAccess;
    balance: number;
    deposit: number;
    id: string;
    created_date: string;
    label: string;
    status: string;
  };
  export type TGateAccess = {
    code: string;
    timezone: string;
    status: string;
  };

  export type TPasswordResetData = {
    userName: string;
    newPassword: string;
    confirmPassword: string;
    oneTimeCode: string;
  };

  export type TLocationDetail = {
    location_name: string;
    location_state: string;
    location_city: string;
    facility_sms_id: string;
  };

  export type TLoginForm = {
    EncryptPass: (
      username: string,
      password: string,
      error: any,
      hasError: any
    ) => void;
    bannerMessage?: string;
    sessionExpired?: boolean;
    locationDetails: TLocationDetail[];
    loggedInSmsFacilityId: string;
    setLoggedInSmsFacilityId: React.Dispatch<React.SetStateAction<string>>;
    historyLocation: any;
  };
  export type TForgotPassword = {
    sendAccessCode: (e: string, notify: any, error: any, hasError: any) => void;
  };

  export type TPasswordReset = {
    resetPassword: (e: any, notify: any, error: any, hasError: any) => void;
  };

  export type TErrorMessage = {
    children: JSX.Element | JSX.Element[];
    messageTitle?: string;
    messageDescription?: string;
  };

  export type TAccountSelectionUnitRes = {
    data: TDataEntity[];
    relational_data: RelationalData;
  };
  export type TDataEntity = {
    next_rent_assessment_rate: number;
    next_bill_start_day: number;
    rental_status: string;
    unit_type: TUnitTypeOrLedgerOrFacility;
    paid_to_date: string;
    next_rent_assessment_date: string;
    bev?: any;
    additional_rental_info?: any;
    rental_deposit: number;
    move_in_date: string;
    id: string;
    second_month_prorate_amount?: null;
    ledger: TUnitTypeOrLedgerOrFacility;
    promo_plans?: null[] | null;
    period: string;
    overlock_status: string;
    comments?: string | null;
    next_amount_payable: number;
    current_rate: number;
    label: string;
    availability_status: string;
    late_since_bill_info?: any;
    rent_charge_category_id: string;
    facility: TUnitTypeOrLedgerOrFacility;
    last_move_out_date?: string | null;
    status: string;
    expected_move_out_date?: null;
    expected_move_out_notification_date?: null;
  };
  export type TUnitTypeOrLedgerOrFacility = {
    id: string;
  };

  export interface RelationalData {
    unit_type: UnitTypeEntity[];
  }
  export interface UnitTypeEntity {
    entity_type: string;
    id: string;
    entity_id: string;
    config_type: string;
    value: Value;
  }
  export interface Value {
    tfw?: any;
    rate?: any;
    fee?: any;
    description: string;
    lease_style?: any;
    category: string[];
    dimension?: any;
    overbook_by: number;
    status: string;
    rent_slider?: any | null;
  }

  export type TReservation = {
    ledger: {
      id: string;
      label: string;
    };
    reservation_code: string;
    reservation_date: string;
    unit_type_id: string;
    id: string;
    rental_info: {
      setup_fee: number;
      period: string;
      unit_rate: number;
      waive: Record<string, unknown>;
      bill_to_date: string;
      rental_deposit: number;
      move_in_date: string;
      reservation_deposit: number;
      tenant_deposit: number;
    };
    unit_id: string;
    unit_label?: string;
    unit_type_description?: string;
    facility: {
      id: string;
    };
    reservation_config: {
      lock_reservation_rates: boolean;
    };
    tenant: {
      name: {
        last_name: string;
      };
      id: string;
    };
    status: string;
  };
}
